var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "PIX 类型", prop: "pix_type" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择 PIX 类型" },
              on: { change: _vm.handlePixTypeChange },
              model: {
                value: _vm.form.pix_type,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "pix_type", $$v)
                },
                expression: "form.pix_type",
              },
            },
            _vm._l(_vm.pixTypeOptions, function (opt) {
              return _c("el-option", {
                key: opt.value,
                attrs: { label: opt.label, value: opt.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: _vm.pixValueLabel, prop: "card_no" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: _vm.pixValuePlaceholder,
              maxlength: _vm.inputMaxLength,
              "show-word-limit": !!_vm.inputMaxLength,
              clearable: "",
            },
            on: { input: _vm.handleCardNoFormat },
            model: {
              value: _vm.form.card_no,
              callback: function ($$v) {
                _vm.$set(_vm.form, "card_no", $$v)
              },
              expression: "form.card_no",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }